var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.04 12.48 16 16.88l-7.04-4.4v-1.76l7.04 4.4 7.04-4.4zm0-3.52H8.96c-.978 0-1.76.784-1.76 1.76v10.56a1.76 1.76 0 0 0 1.76 1.76h14.08a1.76 1.76 0 0 0 1.76-1.76V10.72a1.76 1.76 0 0 0-1.76-1.76"
})));
export default SvgEmail;